module.exports = {
    text: "<p>We use cookies to monitor user traffic on the site. Using our site means that they will be posted on your device. You can change your browser settings at any time. See <strong><a href='/en/privacy-policy' target='_blank'>Privacy policy</a></strong> </p>",
    link: "Privacy Policy"
}
